<p-dialog
  #staticDialog
  [header]="'TERMS.TITLE' | translate"
  [modal]="true"
  [(visible)]="termsOfuseDialogVisible"
  (visibleChange)="termsOfuseDialogVisibleChange.emit($event)"
  [style]="{ width: '100vw', height: '100vh', maxHeight: '100vh' }"
  [breakpoints]="{ '74.9375rem': '75vw', '35.9375rem': '90vw' }"
>
  <div class="max-w-none lg:max-w-[50%] mx-auto">
    <h2 class="sr-only">{{ 'TERMS.TITLE' | translate }}</h2>
    <p>
      {{ 'TERMS.BODY_PREFIX' | translate }}
      <a
        href="https://www.eaton.com/us/en-us/company/policies-and-statements/privacy-cookies-and-data-protection.html"
        target="_blank"
        >{{ 'TERMS.POLICY_LINK_TEXT' | translate }}</a
      >
    </p>
  </div>
</p-dialog>
